import Vote from './Vote'

export default Vote
// eslint-disable-next-line import/export
export * from './Vote'
